import type { ReactNode } from 'react';
import { isBetaFeatureEnabled, type BetaHeldFeature } from '../../config/beta-surface';
import { BetaHoldPage } from './BetaHoldPage';

interface BetaRouteGuardProps {
  feature: BetaHeldFeature;
  children: ReactNode;
}

export function BetaRouteGuard({ feature, children }: BetaRouteGuardProps) {
  if (isBetaFeatureEnabled(feature)) return <>{children}</>;
  return <BetaHoldPage feature={feature} />;
}

